import React from 'react'
import { Typography } from '@telus/koodo-ui-kit'
import EPSCard from '@apps/components/CreditDebitCard/EPSCard'
import CreditDebitCard from '@apps/components/CreditDebitCard'

const CreditCardSection = ({
  textContent,
  paymentGateway,
  handleSIMActivation,
  showErrors,
  setButtonIsLoading,
  validCreditCardContent,
  voucherRequiredRef,
  // Only the voucher + auto-top-up flow passes this; the plain credit-card flow
  // has no voucher to fall short. EPSCard defaults it to false, so the default
  // here is the same and is what the card-only path relies on.
  hasInsufficientVoucherCodeError = false
}) => (
  <div className="space-y-5">
    <div>
      <Typography variant={{ size: 'h4' }}>
        {textContent?.shortTextFields?.creditCardDetailsTitle}
      </Typography>
    </div>
    {paymentGateway === 'EPS' && (
      <EPSCard
        handleSIMActivation={handleSIMActivation}
        showErrors={showErrors}
        textContent={textContent}
        setButtonIsLoading={setButtonIsLoading}
        validCreditCardContent={validCreditCardContent}
        voucherRequiredRef={voucherRequiredRef}
        hasInsufficientVoucherCodeError={hasInsufficientVoucherCodeError}
      />
    )}
    {paymentGateway === 'SALT' && (
      <CreditDebitCard
        showErrors={showErrors}
        textContent={textContent}
        validCreditCardContent={validCreditCardContent}
      />
    )}
  </div>
)

export default CreditCardSection
